import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import AppliedRoute from "./components/AppliedRoute";

/**DONATIONS**/
import Offers from './containers/offers';
import OffersNew from "./containers/offers/new.js";
import OffersEdit from './containers/offers/edit.js'
import ClinicHistory from './containers/clinic_history/ClinicHistory';
import ExtractionsNew from "./containers/extractions/new.js";
import Refuses from './containers/refuses';
import ChangeToList from './containers/change_to_list/index';
import EntriesList from './containers/distribution/entries/index';
import Entry from './containers/distribution/entries/entry';
import SearchDonor from './containers/offers/search_donor';
import Fusion from './containers/fusion/';


/*LABORATORY*/
import ResultsDonation from './containers/results_donation/index';
import ResultsNew from "./containers/results_donation/new.js";
import ResultsEdit from "./containers/results_donation/edit.js";
import ValidationDonation from "./containers/validation_donation/index";
import WorkList from "./containers/work_list/index";
import SampleSearch from './containers/search/sample_search';
import DonorSearch from './containers/search/donor_search';
import SampleResults from './containers/laboratory/sample_results';
import EpidemiologicalMonitoring from './containers/laboratory/epidemiological_monitoring/';

/*PROCESS*/
import Centrifuge from './containers/process/centrifuge/index';
import Fractioning from './containers/process/fractioning/index';
import BagsGroup from './containers/process/bags_group/index';
import ListModify from './containers/process/modify/list';
import ModifyComponent from './containers/process/modify/index';
import AliquotsList from './containers/process/aliquots/aliquotsList';
import Aliquots from './containers/process/aliquots/index';
import PoolsReconstruction from './containers/process/pools_reconstruction/index';
import PoolsList from './containers/process/pools_reconstruction/poolsList';
import CrioList from './containers/process/cryoprecipitate/list';
import Cryoprecipitate from './containers/process/cryoprecipitate/index';
import Plasma from './containers/process/plasma/index';
import UnsubsribeUnits from './containers/process/discard_units/index';
import DiscardUnitsList from './containers/process/discard_units/list';
import LabelPrint from './containers/process/labels/index';
import ModifyFractioning from './containers/process/modify_fractioning/ModifyFractioning';
import LockUnitsForm from './containers/process/lockUnits/form';
import LockUnits from './containers/process/lockUnits/';

/*LABELS*/
import LabelsList from './containers/labels/index';

/*Almacen*/
import Warehouse from './containers/warehouse/index';
import UnitsWarehouse from './containers/warehouse/units/index';
import Traceability from './containers/warehouse/donation_traceability/index';
import ExpiredUnits from './containers/warehouse/expiredUnits/';
import StoreUnits from './containers/warehouse/storeUnits/index';
import UnitsNearExpiration from './containers/warehouse/units_near_expiration/';

/*Distribucion*/
import Distribution from './containers/distribution/index';
import Despatch from './containers/distribution/despatch/index';
import DespatchForm from './containers/distribution/despatch/form';
import OrderUnitsDistribution from './containers/distribution/orderUnits/index';
import CinfirmOrderUnits from './containers/distribution/confirm/index';
import Shippings from './containers/distribution/shipping/index';
import ShippingsNew from './containers/distribution/shipping/createShipping';
import FormSendDespatch from './containers/distribution/shipping/form';
import SampleList from './containers/distribution/samples/sampleList';
import Samples from './containers/distribution/samples/index';
import EntryUnits from './containers/distribution/units/index';
import EntryUnitsForm from './containers/distribution/units/form';
import ReportSend from './containers/distribution/shipping/Report';
import Initial from './containers/distribution/initial/';
import Transfer from './containers/distribution/transfer/';
import TransferForm from './containers/distribution/transfer/form';
import DeliveredSearch from './containers/search/delivered_search';
import UnitsCorrection from './containers/distribution/correction/';

/*plasmatic products*/
import PlasmaticProduct from './containers/plasmatic_prod/index';
import PlasmaticProductForm from './containers/plasmatic_prod/form';
import EntriesPlasmatic from './containers/plasmatic_prod/entries/';
import EntriesPlasmaticForm from './containers/plasmatic_prod/entries/form';
import PetitionPlasmatic from './containers/plasmatic_prod/petition/';
import PetitionPlasmaticForm from './containers/plasmatic_prod/petition/form';
import DespatchProducts from './containers/plasmatic_prod/despatch/';
import WarehouseProducts from './containers/plasmatic_prod/warehouse/';
import DevolutionProducts from './containers/plasmatic_prod/devolution/';
import DiscardProduct from './containers/plasmatic_prod/discard/';
import DiscardProductForm from './containers/plasmatic_prod/discard/form';
import PlasmaInactivar from './containers/plasmatic_prod/plasma/';
import PlasmaList from './containers/plasmatic_prod/plasma/list';

/*PATIENTS*/
import PetitionRegister from './containers/patient/petition_register/index';
import NewPetition from './containers/patient/petition_register/new';
import SampleResult from './containers/patient/sample_results/index';
import UnitReserve from './containers/patient/unitReserve/form';
import UnitSend from './containers/patient/petition_register/unitSend';
import SampleResultForm from "./containers/patient/sample_results/edit";
import UnitReturn from './containers/patient/unitReturn/form';
import RemoveReserve from './containers/patient/remove_reserve/';
import Hemovigilance from './containers/patient/hemovigilance/';
import PatientSearch from './containers/patient/search/';
import SearchSample from './containers/patient/samples/sampleSearch'; 
import TransfutionalForm from './containers/patient/hemovigilance/TransfutionalForm';
import UnitDelivered from './containers/patient/unitDelivered/form';
import LabelConfirm from './containers/patient/labelConfirm/';
import BoardHemovigilancia from './containers/patient/hemovigilance/board';
import BoardList from './containers/patient/hemovigilance/boardList';
import ReservedSearch from './containers/patient/search/reserved_search';

/*REPORTS*/
import DonationSummary from './containers/reports/donations/donation_summary/index';
import DonationRegister from './containers/reports/donations/donation_register/index';
import DonationsByCenter from './containers/reports/donations/by_center/index';
import GeneralInfo from './containers/reports/donations/general_info/index';
import DiscardUnits from './containers/reports/process/discardUnits';
import Productivity from './containers/reports/process/productivity';
import FractionUnits from './containers/reports/process/fractionUnits';
import MedicalProductivity from './containers/reports/donations/medical_productivity/index';
import BiometricProductivity from './containers/reports/donations/biometric_productivity/index';
import DonorAgeGender from './containers/reports/donations/donor_age_gender/index';
import StatsDonors from './containers/reports/donations/stats_donors/index';
import DonorByCenter from './containers/reports/donations/donor_by_center/index';
//SE GUARDA import GroupRhStats from './containers/reports/laboratory/GroupRhStats';
import GroupStats from './containers/reports/laboratory/GroupStats';
import AnaliticalTestStats from './containers/reports/laboratory/analiticalTestStats';
import BloodGroups from './containers/reports/laboratory/BloodGroups';
import MadeAliquots from './containers/reports/process/madeAliquots';
import DiscardStats from './containers/reports/process/discardStats';
import SerologyReport from './containers/reports/laboratory/serologyReport';
import Expenses from './containers/reports/distribution/expenses/index';
import UnitsByCenter from './containers/reports/distribution/units_by_center/index';
import SuppliedUnitsStats from './containers/reports/distribution/supplied_units_stats/index';
import ComponentsObtained from './containers/reports/process/componentsObtained';
import UnitsReceived from './containers/reports/distribution/units_received/';
import Income from './containers/reports/distribution/income/';
import ReactionDonations from './containers/reports/donations/reaction_donations/';
import Inventory from './containers/reports/warehouse/inventory';
import MadeCrio from './containers/reports/process/madeCrio';
import UnitTraceability from './containers/reports/warehouse/unitTraceability';
import UserTraceability from './containers/reports/warehouse/userTraceability';
import UnitsTraceability from './containers/reports/warehouse/simpleTraceability';
import DonorByPatient from './containers/reports/patient/donorByPatient/';
import SentPatient from './containers/reports/patient/sentPatient/';
import PlasmaticSend from './containers/reports/plasmatic/plasmaticSend';
import ReservedUnits from './containers/reports/patient/reservedUnits/';
import SerologyHIMFG from './containers/reports/laboratory/serologyHIMFG';
import DeliveredStats from './containers/reports/patient/deliveredStats/';
import DirectoryDonor from './containers/reports/donations/directoryDonor/index';
import Debts from './containers/reports/patient/debts/';
import UnitDeliveredTrans from './containers/reports/patient/unitDeliveredTrans/';
import Discards from './containers/reports/patient/discards/';
import ExpensesBook from './containers/reports/patient/expensesBook/';
import ExpensesIncome from './containers/reports/patient/expenses_income/';
import UnitsReceivedReport from './containers/reports/patient/unitsReceived/';
import ControlTime from './containers/reports/donations/controlTime/';
import IncomeBook from './containers/reports/donations/incomeBook/';
import TestStats from './containers/reports/patient/testStats/';
import RegisteredPetitions from './containers/reports/patient/registeredPetitions/';
import TransfutionalControl from './containers/reports/patient/transfutionalControl/';
import Pending from './containers/reports/patient/pending/';
import DonorStudy from './containers/reports/donations/donor_study/';
import DonorByService from './containers/reports/donations/donorByService/';
import SamplesTraceability from './containers/reports/patient/sample_traceability/';
import IncidentTransfutional from './containers/reports/patient/incidentTransfutional/';
import ExtractionIncident from './containers/reports/donations/extractionIncident/';
import TransfersToCentral from './containers/reports/distribution/transfers_to_central/';
import CNTSReport from './containers/reports/donations/cnts/';
import GeneralExpenses from './containers/reports/distribution/general_expenses/';
import ComponentSupply from './containers/reports/distribution/supplying_component/';
import SerologyIncidents from './containers/reports/donations/serologyIncidents/';
import KardexHemovigilance from './containers/reports/patient/kardexHemovigilance/';
import PlasmaticKardex from './containers/reports/plasmatic/plasmaticKardex';
import PoolsReport from './containers/reports/process/pools';
import DonorPatientNote from './containers/reports/laboratory/donor_patient_note';
import ModifyComp from './containers/reports/process/modifyComp';
import MedicalProductivityDetail from './containers/reports/donations/medical_productivity_detail/';
import Crossmatch from './containers/reports/patient/crossmatch/';
import NurseProductivity from './containers/reports/donations/nurse_productivity/';

/*promotion*/
import Campaign from './containers/promotion/campaign/';
import RegisterCampaign from './containers/promotion/campaign/form';
import Messages from './containers/promotion/messages/';
import ExternalBags from './containers/promotion/externalBags/';

/*Diary*/
import Diary from './containers/diary/';
import DiaryList from './containers/diary/list';
import NewEvent from "./containers/diary/form";

/*HANDHELD*/
import MenuHandheld from './containers/transfusional_control/menu.js';
import HandheldSearchPatient from './containers/transfusional_control/search_patient.js';
import HandheldSampleData from './containers/transfusional_control/sample_data.js';
import TransfusionList from './containers/transfusional_control/transfusion_list';
import TransfusionForm from './containers/transfusional_control/transfusion_form';
import bankReport from "./containers/reports/laboratory/bankReport";
import DeliveryCancel from "./containers/reports/distribution/delivery_cancel/";
import sendStats from "./containers/reports/patient/sendStats/";
import SpecialQueries from "./containers/reports/specialQueries/";
import QualityControl from "./containers/process/quality_control/";
import DonorConvoke from "./containers/reports/donations/donor_convoke/";
import QualityControlReport from "./containers/reports/quality/quality_control";
import componentsQuality from "./containers/reports/quality/componentsQuality";
import DetailsApheresis from "./containers/patient/petition_register/Components/detailsApheresis";
import HemovigilanceReport from "./containers/reports/patient/hemovigilance/";
import EquipmentTemperature from "./containers/quality_control/equipmentTemperature";
import PlasmaticDeliveryStats from "./containers/reports/plasmatic/plasmaticDeliveryStats";
import TransfusionDownload from "./containers/reports/patient/transfution_download/";

/*SUPPLIES*/
import WarehouseSupplies from './containers/supplies/warehouse/index';
import Supplies from './containers/supplies/index';
import SuppliesForm from './containers/supplies/form';
import SuppliesEntries from './containers/supplies/entries/index';
import SuppliesEntriesForm from './containers/supplies/entries/form';
import DiscardSuppliesEntry from './containers/supplies/discard/index';
import DiscardSuppliesEntryForm from './containers/supplies/discard/form';
import SuppliesOutput from './containers/supplies/output/';
import SuppliesOutputForm from './containers/supplies/output/form';
import DonorGrH from "./containers/reports/laboratory/donor_grh";
import EpiMonitoring from "./containers/reports/laboratory/epiMonitoring";
import PrintList from "./containers/plasmatic_prod/plasma/printList";
import PetitionService from "./containers/reports/patient/petitionService";
import HeadshipValidation from "./containers/reports/laboratory/headshipValidation";
import ReactiveDonor from "./containers/reports/laboratory/ReactiveDonor";


import InterviewReport from "./containers/reports/donations/interview/";
import QuestionsResponse from "./containers/offers/interview/questionsResponse";
import SelfExlusionReport from "./containers/reports/donations/self_exclusion/";
import Interview from "./containers/offers/interview";
import Autoexclution from "./containers/offers/autoexclution/";
import SelfExclutionList from "./containers/offers/autoexclution/list";
import ReconstitutionProcess from "./containers/reports/process/ReconstitutionProcess";
import PhenotypesAntibodies from "./containers/reports/laboratory/PhenotypesAntibodies";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <AppliedRoute path="/login" exact component={Login} props={childProps} />

    {/*Diary*/}
    {/*<AppliedRoute path="/diary" exact component={Diary} props={childProps} />*/}
    <AppliedRoute path="/diary" exact component={DiaryList} props={childProps} />
    <AppliedRoute path="/event/new/:date/:hour" exact component={NewEvent} props={childProps} />
    <AppliedRoute path="/event/edit/:id" exact component={NewEvent} props={childProps} />

    {/*REPORTS*/}
    <AppliedRoute path="/donation_summary" exact component={DonationSummary} props={childProps} />
    <AppliedRoute path="/donation_register" exact component={DonationRegister} props={childProps} />
    <AppliedRoute path="/donations_by_center" exact component={DonationsByCenter} props={childProps} />
    <AppliedRoute path="/general_info" exact component={GeneralInfo} props={childProps} />
    <AppliedRoute path="/discard_unit" exact component={DiscardUnits} props={childProps} />
    <AppliedRoute path="/medical_productivity" exact component={MedicalProductivity} props={childProps} />
    <AppliedRoute path="/hematologia_report" exact component={BiometricProductivity} props={childProps} />
    <AppliedRoute path="/donor_age_gender" exact component={DonorAgeGender} props={childProps} />
    <AppliedRoute path="/stats_donors" exact component={StatsDonors} props={childProps} />
    <AppliedRoute path="/fraction_units" exact component={FractionUnits} props={childProps} />
    {/*<AppliedRoute path="/group_rh_stats" exact component={GroupRhStats} props={childProps} />*/}
    <AppliedRoute path="/group_stats" exact component={GroupStats} props={childProps} />
    <AppliedRoute path="/donor_by_center" exact component={DonorByCenter} props={childProps} />
    <AppliedRoute path="/analitical_test_stats" exact component={AnaliticalTestStats} props={childProps} />
    <AppliedRoute path="/blood_groups" exact component={BloodGroups} props={childProps} />
    <AppliedRoute path="/made_aliquots" exact component={MadeAliquots} props={childProps} />
    <AppliedRoute path="/serology_report" exact component={SerologyReport} props={childProps} />
    <AppliedRoute path="/serology_himfg" exact component={SerologyHIMFG} props={childProps} />
    <AppliedRoute path="/expenses" exact component={Expenses} props={childProps} />
    <AppliedRoute path="/units_by_center" exact component={UnitsByCenter} props={childProps} />
    <AppliedRoute path="/discard_stats" exact component={DiscardStats} props={childProps} />
    <AppliedRoute path="/supplied_units_stats" exact component={SuppliedUnitsStats} props={childProps} />
    <AppliedRoute path="/obtained_components" exact component={ComponentsObtained} props={childProps} />
    <AppliedRoute path="/units_received" exact component={UnitsReceived} props={childProps} />
    <AppliedRoute path="/income" exact component={Income} props={childProps} />
    <AppliedRoute path="/reaction_donations" exact component={ReactionDonations} props={childProps} />
    <AppliedRoute path="/inventory" exact component={Inventory} props={childProps} />
    <AppliedRoute path="/made_crioprecipitate" exact component={MadeCrio} props={childProps} />
    <AppliedRoute path="/details_traceability" exact component={UnitTraceability} props={childProps} />
    <AppliedRoute path="/user_traceability" exact component={UserTraceability} props={childProps} />
    <AppliedRoute path="/simple_traceability" exact component={UnitsTraceability} props={childProps} />
    <AppliedRoute path="/donor_by_patient" exact component={DonorByPatient} props={childProps} />
    <AppliedRoute path="/sent_patient" exact component={SentPatient} props={childProps} />
    <AppliedRoute path="/plasmatic_send" exact component={PlasmaticSend} props={childProps} />
    <AppliedRoute path="/reserved_units" exact component={ReservedUnits} props={childProps} />
    <AppliedRoute path="/delivered_stats" exact component={DeliveredStats} props={childProps} />
    <AppliedRoute path="/debts" exact component={Debts} props={childProps} />
    <AppliedRoute path="/unit_delivered_transfuse" exact component={UnitDeliveredTrans} props={childProps} />
    <AppliedRoute path="/expenses_and_discards" exact component={Discards} props={childProps} />
    <AppliedRoute path="/expenses_book" exact component={ExpensesBook} props={childProps} />
    <AppliedRoute path="/units_received_report" exact component={UnitsReceivedReport} props={childProps} />
    <AppliedRoute path="/time_control" exact component={ControlTime} props={childProps} />
    <AppliedRoute path="/income_book" exact component={IncomeBook} props={childProps} />
    <AppliedRoute path="/cnts_report" exact component={CNTSReport} props={childProps} />
    <AppliedRoute path="/patient/test_stats" exact component={TestStats} props={childProps} />
    <AppliedRoute path="/patient/registered_petitions" exact component={RegisteredPetitions} props={childProps} />
    <AppliedRoute path="/patient/transfutional_control_report" exact component={TransfutionalControl} props={childProps} />
    <AppliedRoute path="/pending_validation" exact component={Pending} props={childProps} />
    <AppliedRoute path="/donor_study" exact component={DonorStudy} props={childProps} />
    <AppliedRoute path="/donor_by_service" exact component={DonorByService} props={childProps} />
    <AppliedRoute path="/samples_traceability" exact component={SamplesTraceability} props={childProps} />
    <AppliedRoute path="/general_expenses" exact component={GeneralExpenses} props={childProps} />
    <AppliedRoute path="/component_supply" exact component={ComponentSupply} props={childProps} />
    <AppliedRoute path="/incident_transfutional" exact component={IncidentTransfutional} props={childProps} />
    <AppliedRoute path="/extraction_incident" exact component={ExtractionIncident} props={childProps} />
    <AppliedRoute path="/serology_incidents" exact component={SerologyIncidents} props={childProps} />
    <AppliedRoute path="/kardex_hemovigilance" exact component={KardexHemovigilance} props={childProps} />
    <AppliedRoute path="/plasmatic_kardex" exact component={PlasmaticKardex} props={childProps} />
    <AppliedRoute path="/expenses_income_book" exact component={ExpensesIncome} props={childProps} />
    <AppliedRoute path="/pools_report" exact component={PoolsReport} props={childProps} />
    <AppliedRoute path="/donor_patient_note" exact component={DonorPatientNote} props={childProps} />
    <AppliedRoute path="/transformation_process" exact component={ModifyComp} props={childProps} />
    <AppliedRoute path="/medical_productivity_detail" exact component={MedicalProductivityDetail} props={childProps} />
    <AppliedRoute path="/crossmatch_time" exact component={Crossmatch} props={childProps} />
    <AppliedRoute path="/nurse_productivity" exact component={NurseProductivity} props={childProps} />
    <AppliedRoute path="/shipments_canceled" exact component={DeliveryCancel} props={childProps} />
    <AppliedRoute path="/shipping_statics" exact component={sendStats} props={childProps} />
    <AppliedRoute path="/special_queries" exact component={SpecialQueries} props={childProps} />
    <AppliedRoute path="/donors_convoke_place" exact component={DonorConvoke} props={childProps} />
    <AppliedRoute path="/hemovigilance_report" exact component={HemovigilanceReport} props={childProps} />
    <AppliedRoute path="/product_export_stats" exact component={PlasmaticDeliveryStats} props={childProps} />
    <AppliedRoute path="/group_rh_report" exact component={DonorGrH} props={childProps} />
    <AppliedRoute path="/epi_monitoring_report" exact component={EpiMonitoring} props={childProps} />
    <AppliedRoute path="/petitions_by_service_stats" exact component={PetitionService} props={childProps} />
    <AppliedRoute path="/headship_validation_report" exact component={HeadshipValidation} props={childProps} />
    <AppliedRoute path="/transfers_to_central" exact component={TransfersToCentral} props={childProps} />
    <AppliedRoute path="/reactive_donor" exact component={ReactiveDonor} props={childProps} />
    <AppliedRoute path="/report/interview" exact component={InterviewReport} props={childProps} />
    <AppliedRoute path="/report/phenotypes_antibodies" exact component={PhenotypesAntibodies} props={childProps} />

    { /* DONORS */ }
    <AppliedRoute path="/offers" exact component={Offers} props={childProps} />
    <AppliedRoute path="/offers/new/:caller_id" exact component={OffersNew} props={childProps} />
    <AppliedRoute path="/offers/register/:preoffer_id" exact component={OffersNew} props={childProps} />
    <AppliedRoute path="/offers/edit/:id/:donor_id/:donation_id/:extraction_incident_id/:caller/:donation_number" exact component={OffersEdit} props={childProps} />
    <AppliedRoute path="/offers/:caller_id/:id" exact component={OffersEdit} props={childProps} />
    <AppliedRoute path="/clinic_history/:offers_id/:donor_id" exact component={ClinicHistory} props={childProps} />
    <AppliedRoute path="/interview/clinic_history/:offers_id/:donor_id/:monitoring_id" exact component={ClinicHistory} props={childProps} />
    <AppliedRoute path="/extractions/new/:offers_id/:donor_id/:donation_id/:extraction_incident_id/:caller_id/:donation_number" exact component={ExtractionsNew} props={childProps} />
    <AppliedRoute path="/refuses" exact component={Refuses} props={childProps} />
    <AppliedRoute path="/biometrics" exact component={Offers} props={childProps} />
    <AppliedRoute path="/clinic_history" exact component={Offers} props={childProps} />
    <AppliedRoute path="/vital_signs" exact component={Offers} props={childProps} />
    <AppliedRoute path="/extractions" exact component={Offers} props={childProps} />
    <AppliedRoute path="/register" exact component={Offers} props={childProps} />
    <AppliedRoute path="/change_list/:health_id" exact component={ChangeToList} props={childProps} />
    <AppliedRoute path="/labels_list" exact component={LabelsList} props={childProps} />
    <AppliedRoute path="/multiple_reprint" exact component={LabelsList} props={childProps} />
    <AppliedRoute path="/samples" exact component={SampleList} props={childProps} />
    <AppliedRoute path="/samples/new" exact component={Samples} props={childProps} />
    <AppliedRoute path="/samples/edit/:id" exact component={Samples} props={childProps} />
    <AppliedRoute path="/second_samples/edit/:id/:donor_id" exact component={Samples} props={childProps} />
    <AppliedRoute path="/second_samples/edit/:id" exact component={Samples} props={childProps} />
    <AppliedRoute path="/search_donor" exact component={SearchDonor} props={childProps} />
    <AppliedRoute path="/search_donor/:donation_id" exact component={SearchDonor} props={childProps} />
    <AppliedRoute path="/fusion/donor" exact component={Fusion} props={childProps} />
    <AppliedRoute path="/directory_donor" exact component={DirectoryDonor} props={childProps} />
    <AppliedRoute path="/bank_summary" exact component={bankReport} props={childProps} />
    <AppliedRoute path="/transfusion_discharges" exact component={TransfusionDownload} props={childProps} />
    <AppliedRoute path="/interview" exact component={Interview} props={childProps} />
    <AppliedRoute path="/autoexclution/new" exact component={Autoexclution} props={childProps} />
    <AppliedRoute path="/autoexclution/edit/:id" exact component={Autoexclution} props={childProps} />
    <AppliedRoute path="/autoexclution" exact component={SelfExclutionList} props={childProps} />
    <AppliedRoute path="/questionnaire_response" exact component={QuestionsResponse} props={childProps} />
    <AppliedRoute path="/self_exclusion_report" exact component={SelfExlusionReport} props={childProps} />
    <AppliedRoute path="/reconstitution_process" exact component={ReconstitutionProcess} props={childProps} />


    {/*Control de calidad */}
    <AppliedRoute path="/st_report" exact component={QualityControlReport} props={childProps} />
    <AppliedRoute path="/quality_component" exact component={componentsQuality} props={childProps} />
    
    { /* LABORATORY */ }
    <AppliedRoute path="/results_donation" exact component={ResultsDonation} props={childProps} />
    <AppliedRoute path="/results_donation/new/:donation_id/:group_test_id" exact component={ResultsNew} props={childProps} />
    <AppliedRoute path="/results_donation/edit/:sample_id/:donation_id/:group_test_id" exact component={ResultsEdit} props={childProps} />
     <AppliedRoute path="/results_donation/edit/search/:sample_id/:donation_id/:group_test_id" exact component={ResultsEdit} props={childProps} />
    <AppliedRoute path="/sample_results/edit/:sample_id/:donation_id/:group_test_id" exact component={ResultsEdit} props={childProps} />
    <AppliedRoute path="/work_list" exact component={WorkList} props={childProps} />
    <AppliedRoute path="/validation_donation" exact component={ValidationDonation} props={childProps} />
    <AppliedRoute path="/sample_search" exact component={SampleSearch} props={childProps} />
    <AppliedRoute path="/donors_search" exact component={DonorSearch} props={childProps} />
    <AppliedRoute path="/sample_results" exact component={SampleResults} props={childProps} />
    <AppliedRoute path="/epidemiological_monitoring" exact component={EpidemiologicalMonitoring} props={childProps} />
    

    {/* PROCESS*/}
    <AppliedRoute path="/centrifuge" exact component={Centrifuge} props={childProps} />
    <AppliedRoute path="/fractioning" exact component={Fractioning} props={childProps} />
    <AppliedRoute path="/bags_group" exact component={BagsGroup} props={childProps} />
    <AppliedRoute path="/modify_component" exact component={ListModify} props={childProps} />
    <AppliedRoute path="/modify_component/new" exact component={ModifyComponent} props={childProps} />
    <AppliedRoute path="/aliquots" exact component={AliquotsList} props={childProps} />
    <AppliedRoute path="/aliquots/new" exact component={Aliquots} props={childProps} />
    <AppliedRoute path="/pools_list" exact component={PoolsList} props={childProps} />
    <AppliedRoute path="/pools" exact component={PoolsReconstruction} props={childProps} />
    <AppliedRoute path="/reconstitucion" exact component={PoolsReconstruction} props={childProps} />
    <AppliedRoute path="/cryoprecipitate_list" exact component={CrioList} props={childProps} />
    <AppliedRoute path="/cryoprecipitate" exact component={Cryoprecipitate} props={childProps} />
    {/*<AppliedRoute path="/plasma" exact component={Plasma} props={childProps} />*/}
    <AppliedRoute path="/discard_units" exact component={UnsubsribeUnits} props={childProps} />
    <AppliedRoute path="/discard_units_list" exact component={DiscardUnitsList} props={childProps} />
    <AppliedRoute path="/discard_units/:folio" exact component={UnsubsribeUnits} props={childProps} />
    <AppliedRoute path="/print_labels" exact component={LabelPrint} props={childProps} />
    {/*<AppliedRoute path="/productivity" exact component={Productivity} props={childProps} />*/}
    <AppliedRoute path="/modify_fractioning" exact component={ModifyFractioning} props={childProps} />
    <AppliedRoute path="/label_confirm" exact component={LabelConfirm} props={childProps} /> 
    <AppliedRoute path="/lock_units" exact component={LockUnits} props={childProps} />
    <AppliedRoute path="/lock_units/new" exact component={LockUnitsForm} props={childProps} />
    <AppliedRoute path="/quality_control" exact component={QualityControl} props={childProps} />

    {/*Warehouse*/}
    <AppliedRoute path="/warehouse" exact component={Warehouse} props={childProps} />  
    <AppliedRoute path="/expired_units" exact component={ExpiredUnits} props={childProps} />  
    <AppliedRoute path="/warehouse/units" exact component={UnitsWarehouse} props={childProps} />
    <AppliedRoute path="/units_near_expiration" exact component={UnitsNearExpiration} props={childProps} />  
    {/*<AppliedRoute path="/warehouse/donation_traceability" exact component={Traceability} props={childProps} />   */}
    
    <AppliedRoute path="/warehouse/storeUnits" exact component={StoreUnits} props={childProps} /> 

    {/*distribution*/} 
    <AppliedRoute path="/distribution" exact component={Distribution} props={childProps} />
    {/*<AppliedRoute path="/despatch" exact component={Despatch} props={childProps} />*/}
    <AppliedRoute path="/distribution/despatch/:id" exact component={DespatchForm} props={childProps} />
    <AppliedRoute path="/distribution/orderUnits/:id" exact component={OrderUnitsDistribution} props={childProps} />
    <AppliedRoute path="/confirm/:id" exact component={CinfirmOrderUnits} props={childProps} />
    <AppliedRoute path="/shippings" exact component={Shippings} props={childProps} />
    <AppliedRoute path="/shippings/new" exact component={ShippingsNew} props={childProps} />
    <AppliedRoute path="/shippings/edit/:id" exact component={ShippingsNew} props={childProps} />
    <AppliedRoute path="/shippings/report/:tipo/:id" exact component={ReportSend} props={childProps} />
    <AppliedRoute path="/bag_entries" exact component={EntriesList} props={childProps} />
    <AppliedRoute path="/bag_entries/new" exact component={Entry} props={childProps} />
    <AppliedRoute path="/bag_entries/edit/:id" exact component={Entry} props={childProps} />
    <AppliedRoute path="/unit_transfer" exact component={Transfer} props={childProps} />
    <AppliedRoute path="/unit_transfer/automatic" exact component={TransferForm} props={childProps} />
    <AppliedRoute path="/unit_transfer/new" exact component={TransferForm} props={childProps} />
    <AppliedRoute path="/unit_transfer/confirm/:id" exact component={TransferForm} props={childProps} />
    <AppliedRoute path="/delivered_search" exact component={DeliveredSearch} props={childProps} />
    <AppliedRoute path="/shippings_despatch" exact component={FormSendDespatch} props={childProps} />
    
    <AppliedRoute path="/initial_load" exact component={Initial} props={childProps} />
    <AppliedRoute path="/entry_units" exact component={EntryUnits} props={childProps} />
    <AppliedRoute path="/entry_units/new" exact component={EntryUnitsForm} props={childProps} />
    <AppliedRoute path="/entry_units/edit/:id" exact component={EntryUnitsForm} props={childProps} />
    <AppliedRoute path="/units_correction" exact component={UnitsCorrection} props={childProps} />

    {/*plasmatic products*/}
    <AppliedRoute path="/plasmatic_products" exact component={PlasmaticProduct} props={childProps} />
    <AppliedRoute path="/plasmatic_products/despatch/:id" exact component={DespatchProducts} props={childProps} />
    <AppliedRoute path="/plasmatic_products/new" exact component={PlasmaticProductForm} props={childProps} />
    <AppliedRoute path="/plasmatic_products/edit/:id" exact component={PlasmaticProductForm} props={childProps} />
    <AppliedRoute path="/entries_plasmatic_products" exact component={EntriesPlasmatic} props={childProps} />
    <AppliedRoute path="/entries_plasmatic_products/new" exact component={EntriesPlasmaticForm} props={childProps} />
    <AppliedRoute path="/entries_plasmatic_products/edit/:id" exact component={EntriesPlasmaticForm} props={childProps} />
    <AppliedRoute path="/petition_plasmatic_products" exact component={PetitionPlasmatic} props={childProps} />
    <AppliedRoute path="/petition_plasmatic_products/new" exact component={PetitionPlasmaticForm} props={childProps} />
    <AppliedRoute path="/petition_plasmatic_products/edit/:id" exact component={PetitionPlasmaticForm} props={childProps} />
    {/*<AppliedRoute path="/petition_plasmatic_products/confirm/:id" exact component={ConfirmPlasmatic} props={childProps} />*/}
    <AppliedRoute path="/plasmatic_products/warehouse" exact component={WarehouseProducts} props={childProps} />
    <AppliedRoute path="/plasmatic_products/devolution/:id" exact component={DevolutionProducts} props={childProps} />
    <AppliedRoute path="/plasmatic_products/discard" exact component={DiscardProduct} props={childProps} />
    <AppliedRoute path="/plasmatic_products/discard/new" exact component={DiscardProductForm} props={childProps} />
    <AppliedRoute path="/plasmatic_products/plasma/new" exact component={PlasmaInactivar} props={childProps} />
    <AppliedRoute path="/plasmatic_products/plasma/edit/:id" exact component={PlasmaInactivar} props={childProps} />
    <AppliedRoute path="/plasmatic_products/plasma" exact component={PlasmaList} props={childProps} />
    <AppliedRoute path="/plasmatic_products/plasma/print/:id" exact component={PrintList} props={childProps} />

    {/*patient*/}
    <AppliedRoute path="/petition_register" exact component={PetitionRegister} props={childProps} />
    <AppliedRoute path="/petition_register/new" exact component={NewPetition} props={childProps} />
    <AppliedRoute path="/petition_register/edit/:id" exact component={NewPetition} props={childProps} />
    <AppliedRoute path="/petition_register/view/:id" exact component={NewPetition} props={childProps} />
    <AppliedRoute path="/petition_register/reserve/:id" exact component={UnitReserve} props={childProps} />
    <AppliedRoute path="/petition_register/unitSend/:id" exact component={UnitSend} props={childProps} />
    {/*<AppliedRoute path="/petition_register/send_products/:id" exact component={UnitSend} props={childProps} />*/}
    <AppliedRoute path="/sample_result" exact component={SampleResult} props={childProps} />
    <AppliedRoute path="/sample_results/:sample_id/:petition_id/:group_test_id" exact component={SampleResultForm} props={childProps} />
    <AppliedRoute path="/unit_return/:id" exact component={UnitReturn} props={childProps} />
    <AppliedRoute path="/remove_reserve" exact component={RemoveReserve} props={childProps} />
    <AppliedRoute path="/fusion/patient" exact component={Fusion} props={childProps} />
    <AppliedRoute path="/hemovigilance" exact component={Hemovigilance} props={childProps} />
    <AppliedRoute path="/patient_search" exact component={PatientSearch} props={childProps} />
    <AppliedRoute path="/patient_search/:patient_id" exact component={PatientSearch} props={childProps} />
    <AppliedRoute path="/sample_patient_search" exact component={SearchSample} props={childProps} />
    <AppliedRoute path="/transfutional_control/:id" exact component={TransfutionalForm} props={childProps} /> 
    <AppliedRoute path="/unit_delivered" exact component={UnitDelivered} props={childProps} /> 
    <AppliedRoute path="/board_hemovigilancia" exact component={BoardHemovigilancia} props={childProps} /> 
    <AppliedRoute path="/board_list" exact component={BoardList} props={childProps} /> 
    <AppliedRoute path="/reserved_search" exact component={ReservedSearch} props={childProps} /> 
    <AppliedRoute path="/apheresis_details/:id" exact component={DetailsApheresis} props={childProps} /> 
    <AppliedRoute path="/work_list/patient" exact component={WorkList} props={childProps} />
    <AppliedRoute path="/validation_donation/patient" exact component={ValidationDonation} props={childProps} />

    {/*promotion*/}
    <AppliedRoute path="/promotion/campaign" exact component={Campaign} props={childProps} />
    <AppliedRoute path="/promotion/campaign/new" exact component={RegisterCampaign} props={childProps} />
    <AppliedRoute path="/promotion/campaign/edit/:id" exact component={RegisterCampaign} props={childProps} />
    <AppliedRoute path="/promotion/messages" exact component={Messages} props={childProps} />
    <AppliedRoute path="/promotion/external_bags" exact component={ExternalBags} props={childProps} />
    <AppliedRoute path="/promotion/offers" exact component={Offers} props={childProps} />
    <AppliedRoute path="/promotion/offers/new/:caller_id" exact component={OffersNew} props={childProps} />
    <AppliedRoute path="/promotion/offers/register/:preoffer_id" exact component={OffersNew} props={childProps} />
    <AppliedRoute path="/promotion/offers/edit/:id/:donor_id/:donation_id/:extraction_incident_id/:caller/:donation_number" exact component={OffersEdit} props={childProps} />
    <AppliedRoute path="/promotion/offers/:caller_id/:id" exact component={OffersEdit} props={childProps} />
    <AppliedRoute path="/promotion/extractions/new/:offers_id/:donor_id/:donation_id/:extraction_incident_id/:caller_id/:donation_number" exact component={ExtractionsNew} props={childProps} />

    {/*quality control */}
    <AppliedRoute path="/equipment_temperature" exact component={EquipmentTemperature} props={childProps} />

    {/*HANDHELD*/}
    <AppliedRoute path="/transfusional_control" exact component={MenuHandheld} props={childProps} />
    <AppliedRoute path="/transfusional_control/samples" exact component={HandheldSearchPatient} props={childProps} />
    <AppliedRoute path="/transfusional_control/sample_data/:patient_id/:number" exact component={HandheldSampleData} props={childProps} />
    <AppliedRoute path="/transfusional_control/list" exact component={TransfusionList} props={childProps} />
    <AppliedRoute path="/transfusional_control/form/:id" exact component={TransfusionForm} props={childProps} />
    
    <AppliedRoute path="/transfusional_control/end/list" exact component={TransfusionList} props={childProps} />
    <AppliedRoute path="/transfusional_control/incident/list" exact component={TransfusionList} props={childProps} />
    
    {/* SUPPLIES */}
    <AppliedRoute path="/supplies_reagents/warehouse" exact component={WarehouseSupplies} props={childProps} />
    <AppliedRoute path="/supplies_reagents" exact component={Supplies} props={childProps} />
    <AppliedRoute path="/supplies_reagents/new" exact component={SuppliesForm} props={childProps} />
    <AppliedRoute path="/supplies_reagents/edit/:id" exact component={SuppliesForm} props={childProps} />
    <AppliedRoute path="/supplies_entries" exact component={SuppliesEntries} props={childProps} />
    <AppliedRoute path="/supplies_entries/new" exact component={SuppliesEntriesForm} props={childProps} />
    <AppliedRoute path="/supplies_entries/edit/:id" exact component={SuppliesEntriesForm} props={childProps} />
    <AppliedRoute path="/supplies_reagents/discard" exact component={DiscardSuppliesEntry} props={childProps} />
    <AppliedRoute path="/supplies_reagents/discard/new" exact component={DiscardSuppliesEntryForm} props={childProps} />
    <AppliedRoute path="/supplies_reagents/output" exact component={SuppliesOutput} props={childProps} />
    <AppliedRoute path="/supplies_reagents/output/new" exact component={SuppliesOutputForm} props={childProps} />
    

    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;